import React, { useState, useEffect } from "react";
import RadarDot from "./RadarDot";
import ShipDiagram from "./ShipDiagram";
import TopFastestShips from "./TopFastestShips";
import TopFuelConsumption from "./TopFuelConsumption";
import ShipMessageBoard from "./ShipMessageBoard";
import SystemOverview from "./SystemOverview";
import RadarGreenWorld from "./RadarGreenWorld";
import StatusLights from "./StatusLights";
import ShipEngineLayout from "./ShipEngineLayout";
import { ShipMessage } from "../types/ShipMessage";
import { ShipPosition } from "../types/ShipPosition";

interface ControlPanelProps {
  controlPanel: {
    shipCount: number;
    avgSpeed: number;
    portCount: number;
    messageData: ShipMessage[] | null;
    fastShipsData: ShipPosition[] | null;
    fuelConsumptionData: ShipPosition[] | null;
  };
}

function ControlPanel({ controlPanel }: ControlPanelProps) {
  const [countdown, setCountdown] = useState(60);
  const [isPanelVisible, setIsPanelVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => (prev === 0 ? 60 : prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Toggle Button - only visible on small screens */}
      <button
        className="fixed bottom-4 right-4 z-50 bg-black text-white px-3 py-2 rounded-md md:hidden"
        onClick={() => setIsPanelVisible((prev) => !prev)}
      >
        {isPanelVisible ? "Hide Panel" : "Show Panel"}
      </button>

      {/* Control Panel */}
      <div
        className={`${
          isPanelVisible ? "flex" : "hidden"
        } md:flex absolute bottom-4 left-4 bg-black/70 backdrop-blur-md rounded-lg shadow-lg p-4 flex-wrap gap-4 text-white text-xs font-mono z-40`}
      style={{
        zoom: "0.8",
    
      }}
      >
        <SystemOverview
          shipCount={controlPanel.shipCount}
          avgSpeed={controlPanel.avgSpeed}
          portCount={controlPanel.portCount}
        />

        <TopFastestShips fastShipsData={controlPanel.fastShipsData}/>

        <RadarGreenWorld />

        <RadarDot />

        <ShipDiagram />

        <ShipMessageBoard messageData={controlPanel.messageData}/>

        <ShipEngineLayout />

        <TopFuelConsumption fuelConsumptionData={controlPanel.fuelConsumptionData}/>

        <StatusLights />
      </div>
    </>
  );
}

export default ControlPanel;
